import { render, staticRenderFns } from "./CwvSitesPerformance.vue?vue&type=template&id=b23fd2b8&"
import script from "./CwvSitesPerformance.vue?vue&type=script&lang=js&"
export * from "./CwvSitesPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports